/**
 * @param {string} scriptPart specify part of the script url
 * @param {number} includePathElements how many path elements to keep after the domain (0 = just the bare domain will be used)
 * @returns {string} the base url: protocol + domain + port
 */
export function getBaseUrlByScript(scriptPart, includePathElements = 0) {
  const scripts = document.querySelectorAll('script[src]');

  for (let i = 0; i < scripts.length; i++) {
    const script = scripts.item(i);
    const src = script.getAttribute('src');
    if (src.indexOf(scriptPart) > 0) {
      return extractBaseUrl(src, includePathElements);
    }
  }
}

const extractBaseUrl = (url, includePathElements) => {
  const match = url.match(/(https?:)?\/\/([^/]+)/);
  if (match) {
    const [ , protocol, host ] = match;
    if (host) {
      let res = (protocol || '') + '//' + host;
      if (includePathElements > 0) {
        res += '/' + url.replace(res + '/', '').split('/').slice(0, includePathElements).join('/');
      }
      return res;
    }
  }
};

/**
 * Extracts important parts from an url for normalization.
 * @param {string} urlStr the "url" in string format to be normalized
 * @param {string} defaultProtocol default protocol to use when urlStr doesn't include one
 * @param {boolean} noWww if used, will strip the url of 'www.' subdomain if found
 */
export const extractNormalUrlParts = (urlStr, { defaultProtocol = 'https', noWww = false } = {}) => {
  if (!urlStr) {
    return { protocol: '', host: '', pathname: '' }
  }
  if (!urlStr.match(/^(\w+):\/\//)) {
    urlStr = `${defaultProtocol}://${urlStr}`;
  }
  const url = new URL(urlStr);
  let host = url.host;
  if (noWww) {
    host = host.replace(/^www\./, '');
  }
  return { protocol: url.protocol, host, pathname: url.pathname };
};

/**
 * Perform cleanup on urls to yield normalized version, as needed in most cases, e.g. for comparison.
 * @param {string} urlStr the "url" in string format to be normalized
 * @param {object} [opts]
 * @param {string} [opts.defaultProtocol] default protocol to use when urlStr doesn't include one
 * @param {boolean} [opts.noWww] if used, will strip the url of 'www.' subdomain if found
 * @returns {string}
 */
export const normalizeUrl = (urlStr, opts) => {
  const { protocol, host, pathname } = extractNormalUrlParts(urlStr, opts);
  return `${protocol}//${host}${pathname}`;
};
